/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {slideInOutAnimation as ɵe} from './lib/animations/slide-in-out.animation';
export {WorkspaceDefaultConfig as ɵa} from './lib/config/default.config';
export {IWorkspaceConfig as ɵc} from './lib/models/i-workspace.config';
export {WorkspaceConfig as ɵg} from './lib/models/workspace-config.model';
export {CONFIG as ɵb} from './lib/models/workspace-config.token';
export {NgsWorkspaceComponent as ɵd} from './lib/ngs-workspace.component';
export {NoTabComponent as ɵf} from './lib/no-tab/no-tab.component';